import { render, staticRenderFns } from "./AlertEventDialogUsersTabComponent.vue?vue&type=template&id=b79b270e&scoped=true"
import script from "./AlertEventDialogUsersTabComponent.js?vue&type=script&lang=js&external"
export * from "./AlertEventDialogUsersTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertEventDialogUsersTabComponent.vue?vue&type=style&index=0&id=b79b270e&prod&scoped=true&lang=scss"
import style1 from "./AlertEventDialogUsersTabComponent.vue?vue&type=style&index=1&id=b79b270e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79b270e",
  null
  
)

export default component.exports